<div class="modal is-active">
  <div class="modal-background"></div>
  <div class="modal-content">

    <div class="cp-header">
      <div class="cp-label">
        {{ 'warranty_extension' | translate }}
      </div>
      <div class="cp-button" (click)="close()">
        <img src="assets/img/ic-close.png"/>
      </div>
    </div>

    @if (registeredSerial() && registeredSerial()?.warrantyAcceptDate !== null) {
    <div class="content">
      <img class="cp-img" src="/assets/img/ic-warranty-ok.png">

      <div class="cp-title">
        {{ 'warranty_ok_title' | translate }}
      </div>
      <div class="cp-subtitle cp-m-top-8">
        {{ 'warranty_ok_subtitle1' | translate }}
      </div>
      <div class="cp-subtitle cp-m-top-6">
        {{ 'warranty_ok_subtitle2' | translate }} <span class="cp-bold">{{ email() }}</span>
      </div>

      <div class="cp-box">

        <div class="cp-box-row">
          <div class="cp-box-row-left">
            {{ 'product' | translate }}
          </div>
          <div class="cp-box-row-right">
            {{ registeredSerial()?.trainerName }}
          </div>
        </div>

        <div class="cp-box-row">
          <div class="cp-box-row-left">
            {{ 'serial' | translate }}
          </div>
          <div class="cp-box-row-right">
            {{ registeredSerial()?.serialCode }}
          </div>
        </div>

        <div class="cp-box-row">
          <div class="cp-box-row-left">
            {{ 'warranty_expiry_date' | translate }}
          </div>
          <div class="cp-box-row-right">
            {{ termDate() | dateFormatted }}
          </div>
        </div>

      </div>

      <div class="cp-subtitle cp-m-top-8">
        {{ 'warranty_ok_subtitle3' | translate }}
      </div>
    </div>

    <div class="cp-footer">
      <button class="coupon-button gray" (click)="close()">
        {{ 'close' | translate | uppercase }}
      </button>
    </div>
    }
    @else if (registeredSerial() && registeredSerial()?.warrantyAcceptDate === null) {
    <div class="content">
      <img class="cp-img" src="/assets/img/ic-warranty-ko.png">

      <div class="cp-subtitle cp-m-top-20">
        {{ 'warranty_ko' | translate }}
      </div>
    </div>

    <div class="cp-footer">
      <button class="coupon-button gray" (click)="close()">
        {{ 'close' | translate | uppercase }}
      </button>
    </div>
    }
    @else {
    <div class="content">
      <img class="cp-img rotating" src="/assets/img/ic-warranty-loading.png">

      <div class="cp-subtitle cp-m-top-20">
        {{ 'warranty_ok_waiting' | translate }}
      </div>
    </div>
    }

  </div>
</div>
